
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartAtonIec as ObiChartAtonIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-aton-iec.js';
 
 
 

 
 export const ObiChartAtonIec = createComponent({
   react: React,
   tagName: 'obi-chart-aton-iec',
   elementClass: ObiChartAtonIecElement,
   events: {
     
   }
  });
 
 